const STUDENT_SELECTION = 'student';
const INSTRUCTOR_SELECTION = 'instructor';

export function initStudentInstructorToggleListeners() {
  try {
    const btnGroups = document.querySelectorAll('.studentInstructorToggleGroup');
    const evergreenButtons = document.querySelectorAll('.evergreenExplanationPopover');
    if (!btnGroups?.length) {
      return;
    }
    let savedSelection = getInitialSelection() || STUDENT_SELECTION;

    btnGroups.forEach((btnGroup) => {
      const studentTab = btnGroup.querySelector('[id*="student"]');
      const instructorTab = btnGroup.querySelector('[id*="instructor"]');
      setActiveButton(btnGroup, savedSelection);

      if (studentTab && instructorTab) {
        const pillsTab = btnGroup.querySelector('[id^="pills-tab"]');
        if (pillsTab) {
          pillsTab.addEventListener('click', function (event) {
            event.preventDefault();
            if (!event?.target) {
              return;
            }

            const clickedLink = event.target.closest('.nav-link');
            if (clickedLink?.id) {
              let selectedValue;
              if (clickedLink.id.includes(STUDENT_SELECTION)) {
                selectedValue = STUDENT_SELECTION;
              } else if (clickedLink.id.includes(INSTRUCTOR_SELECTION)) {
                selectedValue = INSTRUCTOR_SELECTION;
              }

              if (selectedValue) {
                syncSelection(selectedValue, btnGroups);
                // Dispatch a custom event
                const customEvent = new CustomEvent('studentInstructorToggleGroupChange', {
                  detail: { value: selectedValue },
                  bubbles: true,
                });

                btnGroup.dispatchEvent(customEvent);
              }
            }
          });
        }
      }
    });

    document.addEventListener('studentInstructorToggleGroupChange', (event) => {
      if (document.body.classList.contains('mhecomm-he-pdp-page') && event.detail?.value) {
        const url = new URL(window.location.href);
        url.searchParams.set('viewOption', event.detail.value);
        window.history.replaceState({}, '', url.toString());
      }
      evergreenButtons.forEach((evergreenButton) => {
        evergreenPopoverListener(event.detail.value, evergreenButton);
      });
    });
    if (document.body.classList.contains('mhecomm-he-pdp-page')) {
      document.addEventListener('studentInstructorToggleStudentState', (event) => {
        btnGroups.forEach((group) => {
          const studentInput = group.querySelector('input[id^="student"]');
          if (studentInput) studentInput.disabled = Boolean(event.detail?.value);
        });
      });
    }
  } catch (error) {
    console.error('Error in student instructor toggle listeners:', error);
  }
}

function evergreenPopoverListener(value, evergreenButton) {
  if (evergreenButton) {
    const popoverInstance = window.bootstrap.Popover.getInstance(evergreenButton);
    if (popoverInstance) {
      popoverInstance.dispose();
    }

    const isStudent = value === 'student';
    evergreenButton.setAttribute(
      'data-bs-content',
      isStudent ? evergreenButton.dataset.bsStudent : evergreenButton.dataset.bsInstructor
    );

    new window.bootstrap.Popover(evergreenButton);
  }
}

export function initInputGroupEvents() {
  document.querySelectorAll('.hePdpStuInsToggleBtnGroup').forEach((btnGroup) => {
    const inputGroup = btnGroup.querySelectorAll('li.nav-item a.btn, li.nav-item button.btn');
    const syncTabStops = () => {
      inputGroup.forEach((el) => {
        const isActive = el.classList.contains('active') || el.getAttribute('aria-selected') === 'true';
        el.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    };

    const setFocusedTabStop = (focusedEl) => {
      inputGroup.forEach((el) => {
        el.setAttribute('tabindex', el === focusedEl ? '0' : '-1');
      });
    };

    const moveFocus = (currentIndex, direction) => {
      const newIndex = (currentIndex + direction + inputGroup.length) % inputGroup.length;
      const nextEl = inputGroup[newIndex];
      nextEl.focus();
      setFocusedTabStop(nextEl);
      if (document.body.classList.contains('mhecomm-he-pdp-page')) nextEl.click();
    };

    syncTabStops();

    inputGroup.forEach((anchorEl, index) => {
      anchorEl.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          event.preventDefault();
          event.stopPropagation();
          // Move focus to the next radio
          moveFocus(index, 1);
        }

        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          event.preventDefault();
          event.stopPropagation();
          // Move focus to the previous radio
          moveFocus(index, -1);
        }

        if (document.body.classList.contains('mhecomm-he-pdp-page') && (event.key === 'Home' || event.key === 'End')) {
          event.preventDefault();
          const target = inputGroup[event.key === 'Home' ? 0 : inputGroup.length - 1];
          target.focus();
          setFocusedTabStop(target);
          target.click();
        }

        // Handle Space or Enter to select the radio button
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          anchorEl.checked = true; // Select the focused radio button
          // Create and dispatch click event
          const clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          });
          anchorEl.dispatchEvent(clickEvent);
        }
      });

      anchorEl.addEventListener('click', () => {
        syncTabStops();
      });

      anchorEl.addEventListener('focus', () => {
        setFocusedTabStop(anchorEl);
      });
    });

    document.addEventListener('studentInstructorToggleGroupChange', () => {
      syncTabStops();
    });

    btnGroup.addEventListener('focusout', (event) => {
      const nextFocused = event.relatedTarget;
      if (!nextFocused || !btnGroup.contains(nextFocused)) {
        syncTabStops();
      }
    });
  });
}

function getInitialSelection() {
  const firstGroup = document.querySelector('.studentInstructorToggleGroup');
  if (firstGroup) {
    const activeBtn = firstGroup.querySelector('.nav-link.active[aria-selected="true"]');
    if (activeBtn) {
      return activeBtn.getAttribute('data-layer-pdp-view-type');
    }
  }
  return null;
}

function syncSelection(selection, studentInstructorGroups) {
  studentInstructorGroups.forEach((group) => {
    setActiveButton(group, selection);
  });
}

function syncActiveTabStops(group) {
  const tabs = group.querySelectorAll('li.nav-item a.btn, li.nav-item button.btn');
  tabs.forEach((tab) => {
    const isActive = tab.classList.contains('active') || tab.getAttribute('aria-selected') === 'true';
    tab.setAttribute('tabindex', isActive ? '0' : '-1');
  });
}

function setActiveButton(group, selection) {
  const studentBtn = group.querySelector('[data-layer-pdp-view-type="student"]');
  const instructorBtn = group.querySelector('[data-layer-pdp-view-type="instructor"]');

  if (selection === STUDENT_SELECTION) {
    studentBtn.classList.add('active');
    studentBtn.setAttribute('aria-selected', 'true');
    instructorBtn.classList.remove('active');
    instructorBtn.setAttribute('aria-selected', 'false');
  } else {
    instructorBtn.classList.add('active');
    instructorBtn.setAttribute('aria-selected', 'true');
    studentBtn.classList.remove('active');
    studentBtn.setAttribute('aria-selected', 'false');
  }

  syncActiveTabStops(group);
}

if (document.readyState !== 'loading') {
  initInputGroupEvents();
  initStudentInstructorToggleListeners();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    initInputGroupEvents();
    initStudentInstructorToggleListeners();
  });
}
